<div class="support-card p-4" *ngIf="hasActiveChannels">
  <div class="row">
    <div class="col-12">
      <div class="company-logo mb-3">
        <div class="logo-container">
          <img
            *ngIf="companyLogo"
            [src]="companyLogo"
            alt="Logo"
            class="company-logo-img"
          />
          <div *ngIf="!companyLogo" class="logo-support-card">
            <i class="fa-solid fa-building"></i>
          </div>
        </div>
      </div>

      <div class="company-info text-center mb-4">
        <h4 *ngIf="showTitle" class="company-name mb-2">{{ title }}</h4>
        <p class="company-description text-muted mb-3">
          {{ description }}
        </p>

        <div
          class="contact-info"
          *ngIf="getRequiredEmail() || getRequiredPhone()"
        >
          <div class="row">
            <div class="col-6" *ngIf="getRequiredEmail()">
              <div class="info-item">
                <span class="info-label">Email</span>
                <div class="info-value" [title]="getRequiredEmail()?.value">
                  {{ getRequiredEmail()?.value }}
                </div>
              </div>
            </div>
            <div class="col-6" *ngIf="getRequiredPhone()">
              <div class="info-item">
                <span class="info-label">Teléfono</span>
                <div class="info-value" [title]="getRequiredPhone()?.value">
                  {{ getRequiredPhone()?.value }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="contact-channels">
        <div
          *ngFor="let channel of getActiveChannels()"
          class="channel-icon-container"
          (click)="onChannelClick(channel)"
          [ngbTooltip]="getChannelTooltip(channel)"
          placement="top"
        >
          <div class="channel-icon" [class]="'channel-' + channel.type">
            <i [class]="getChannelIcon(channel.type)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
